<template>
	<v-hover v-slot="{ hover }">
		<v-card
			:elevation="hover ? 6 : 2"
			class="pb-0 pt-0"
		>
			<v-row class="text-center fill-height" no-gutters>
				<v-col cols="12" class="text-end">
					<v-speed-dial direction="bottom" class="max-36">
						<template #activator>
							<v-tooltip bottom>
								<template #activator=" { on:tooltip } ">
									<v-btn icon v-on="{ tooltip }">
										<v-icon>mdi-dots-vertical</v-icon>
									</v-btn>
								</template>
								<span>مشاركة المحتوى</span>
							</v-tooltip>
						</template>
						<div>
							<v-btn fab dark small color="primary" @click="addToFavorite(record.id)">
								<v-icon>mdi-bookmark-plus</v-icon>
							</v-btn>

							<ShareNetwork 
								v-for="network in networks"
								:key="network.id"
								:network="network.id" 
								:url="base + '/news/' + record.id"
								:title="record.title"
								:description="record.note"
								hashtags="e_ritqa"
								twitter-user="e_ritqa"
							>
								<v-btn fab dark small color="primary">
									<v-icon>{{ network.icon }}</v-icon>
								</v-btn>
							</ShareNetwork>
						</div>
					</v-speed-dial>
				</v-col>

				<v-col v-if="!search" cols="12" class="py-0" style="min-height: 100px; min-width: 100px;">
					<router-link :to="{ name: 'news-item' , params: { recordID: record.id}}">
						<v-img :src="record.coverPic" height="100" contain>
							<template #placeholder>
								<v-row class="fill-height ma-0" align="center" justify="center">
									<v-progress-circular indeterminate color="primary"></v-progress-circular>
								</v-row>
							</template>
						</v-img>
					</router-link>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12">
					<router-link :to="{ name: 'news-item' , params: { recordID: record.id}}">
						<v-card tile flat>
							<v-card-text class="py-1 black--text">
								<h4 class="text-subtitle-1 font-weight-bold text-center max-2-lines">{{ record.title }}</h4>
							</v-card-text>
							<v-card-text v-if="!search" class="py-0">
								<div class="text-body-1 text-center max-2-lines">{{ record.description }}</div>
							</v-card-text>
							<v-card-actions v-if="!search" class="py-0">
								<span v-if="configViewCount" class="pe-2">
									<v-icon>mdi-eye</v-icon>
									{{ record.viewCount }}
								</span>
								<span class="pe-2">
									<v-tooltip v-if="record.publishWri" bottom>
										<template #activator=" {on} ">
											<div color="primary" v-on="on">
												<v-icon>mdi-calendar</v-icon>
												{{ record.publishWri }}
											</div>
										</template>
										<span>{{ record.publishDate.substring(0,10) }}</span>
									</v-tooltip>
								</span>
							</v-card-actions>
						</v-card>
					</router-link>
				</v-col>
			</v-row>
		</v-card>
	</v-hover>
</template>

<script>
import clientNotifier from "@/clientNotifier";

export default {
	props: {
		record: {
			type: Object,
			required: true
		},
		search: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return{ 
			networks: [
				{
					id: "facebook",
					icon: "mdi-facebook"
				},
				{ 
					id: "telegram",
					icon: "mdi-telegram"
				},
				{ 
					id: "twitter",
					icon: "mdi-twitter"
				},
				{ 
					id: "whatsapp",
					icon: "mdi-whatsapp"
				},
				{ 
					id: "email",
					icon: "mdi-email"
				},
			],
		}
	},
	computed: {
		configViewCount() {
			return this.$store.state.viewCount;
		},
		base(){
			return location.origin;
		}
	},
	methods: {
		addToFavorite(id) {
			if (this.$store.state.profile == null) {
				this.$store.dispatch("notify", {
					message: "لتتمكن من الإضافة, يجب عليك أن تكون من احد مستخدمي المنصة",
					color: "error"
				});
				return;
			}

			clientNotifier.post("/api/favorite/addNews/" + id);
		},
	}
}
</script>